import React, { useState, useContext } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import {Button, Form, Row, Col} from 'react-bootstrap';
import { UserContext } from '../../contexts/userContext.js'
import { loginUser } from '../../api/auth.js'
import {form_div_class, form_color_textbox} from "../../settings.js";

// Hook to get query params.
// this could be refactored to somewhere else for future contributors.
function useQueryParams () {
  return new URLSearchParams(useLocation().search);
}

function Login() {
  const queryParams = useQueryParams();
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const {user, setUser, isUserLoggedIn} = useContext(UserContext)
  const [username, setUsername] = useState(true)//const [username, setUsername] = useState("")
  const [password, setPassword] = useState(true)//const [password, setPassword] = useState("")
  const [errorDisplay, setErrorDisplay] = useState("")

  const onLoginFormSubmit = (event) => {
    event.preventDefault();
    if (!isValidForm()){
      return
    }
    loginUser(username, password).then((data)=>{
      window.localStorage.setItem('username', username);
      setUser({username: username});
      history.push(getRouteAfterLogin());
    }).catch((error)=> {
      setErrorDisplay('Log in failed.');
    })
  }

  const getRouteAfterLogin = () => {
    let route = queryParams.get("next")
    if (route === null) {
      route = "/";
    }
    return route
  }

  const isValidForm = () => {
    setErrorDisplay("")
    if (username === "" || password === ""){
      setErrorDisplay("username and password can't be empty. try user: test, password: test")
      return false;
    }
    return true;
  }
  /*
  const logout = () => {
    logoutUser()
    setUser(null);
  }
  */
  const style = {
    "height":"100vh"
  };
  return <div class="container" style = {style}>
        <Row>
            <div class="col-md-2"></div>
            <div class={form_div_class}>
                <div class="pt-3"></div>
                <Form onSubmit={onLoginFormSubmit} method="POST">
                  <Form.Group controlId="username">
                    <Form.Control
                          onChange={(event)=>{setUsername(event.target.value)}}
                          type="text"
                          placeholder="Username"
                          id="username"
                          name="username"
                          style={{"font-family": "monospace", "background":form_color_textbox}}
                          />
                    </Form.Group>
                  <Form.Group controlId="password">
                    <Form.Control
                        onChange={(event)=>{setPassword(event.target.value)}}
                        placeholder="Password"
                        type="password"
                        id="password"
                        name="password"
                        style={{"font-family": "monospace", "background":form_color_textbox}}/>
                    </Form.Group>
                    <Button type="submit" variant="flat" class="font-weight-bold text-monospace">Login</Button>
                  <p style={{color: 'red', 'font-family': 'monospace'}}>{errorDisplay}</p>
                </Form>
                </div>
            <Col class="col-md-2">&nbsp;</Col>
        </Row>
            <Row class="mt-5"> <Col>&nbsp;</Col></Row>

                <footer class="text-center text-white fixed-bottom">
        <div class="text-center p-3" style={{"font-family": "monospace", "color": "lightgray"}}>
            © 2022 Copyright: Shimizu.FI
        </div>
    </footer>
  </div>
}

export default Login;
